/** Original limited palette (NES-adjacent but hand-picked, not a copied palette). */
export const C = {
  // sky / backgrounds
  skyDay: '#63b4f0',
  skyDayLow: '#9adcf7',
  skyDusk: '#5b3f86',
  skyDuskLow: '#e0764f',
  skyCave: '#0f0b1e',
  skyCaveLow: '#1d1436',

  cloud: '#ffffff',
  cloudShade: '#c9e6ff',

  hill: '#3f9b4a',
  hillDark: '#2c7136',
  hillLight: '#63c063',
  bush: '#4bab4b',
  bushDark: '#2f7a37',

  // terrain
  soil: '#b6612c',
  soilDark: '#7d3d18',
  soilLight: '#d98a4a',
  grass: '#4fb84f',
  grassDark: '#2f8c3a',

  brick: '#c9603c',
  brickDark: '#8c3a20',
  brickLight: '#e58c62',
  mortar: '#f6e9d2',

  stone: '#9a8fb5',
  stoneDark: '#645a80',
  stoneLight: '#c3b9d8',

  block: '#e8a83c',
  blockDark: '#a86a14',
  blockLight: '#f7d078',
  blockFace: '#f6e9d2',

  used: '#8a5a2c',
  usedDark: '#5c3a18',
  usedLight: '#b07c46',

  pipe: '#3fb84f',
  pipeDark: '#1f7d33',
  pipeLight: '#7ee07e',

  crystal: '#5c74c8',
  crystalDark: '#33447e',
  crystalLight: '#9aabf0',

  cavesoil: '#6a5a9b',
  cavesoilDark: '#3f3468',
  cavesoilLight: '#8d7dc0',
  cavegrass: '#8b6ad0',
  cavegrassDark: '#5b4499',

  // characters
  skin: '#f6c98f',
  skinDark: '#c98d55',
  leaf: '#5fc63c',
  leafDark: '#2f8c25',
  tunic: '#e0503c',
  tunicDark: '#9b2f24',
  tunicAlt: '#f0f0f0',
  tunicAltDark: '#b8b8c8',
  fireTunic: '#f6f2e6',
  fireTunicDark: '#c9b98f',
  fireTrim: '#e05a1c',
  belt: '#f5c33b',
  boot: '#6b3d1c',
  bootDark: '#42230e',
  outline: '#241a33',
  eye: '#ffffff',

  grub: '#a05ad0',
  grubDark: '#63308c',
  grubBelly: '#f0d8a8',
  grubFoot: '#3f2258',

  snug: '#e8b93c',
  snugDark: '#a87a14',
  shell: '#3fc06a',
  shellDark: '#1f8040',
  shellLight: '#8ce8a8',
  shellRim: '#f6e9d2',

  nipper: '#e8557a',
  nipperDark: '#a02248',
  nipperLight: '#ff9ab0',
  stem: '#4fb84f',
  stemDark: '#2f8c3a',

  // items
  coin: '#f5c33b',
  coinDark: '#b07c14',
  coinLight: '#fff0a8',
  berry: '#e8407a',
  berryDark: '#a01c48',
  berryLight: '#ff9ab8',
  ember: '#ff7a1c',
  emberDark: '#c04a08',
  emberLight: '#ffd06a',
  prism: '#5ce8f0',
  prismDark: '#2a90a8',
  prismLight: '#e0feff',
  pod: '#4fd85f',
  podDark: '#249b3a',

  // ui
  white: '#ffffff',
  black: '#0d0a16',
  hud: '#f6f1e0',
  hudShade: '#241a33',
  gold: '#f5c33b',
  red: '#e0503c',
} as const;

export type ThemeName = 'day' | 'dusk' | 'cave';

export interface Theme {
  skyTop: string;
  skyBottom: string;
  soil: string;
  soilDark: string;
  soilLight: string;
  grass: string;
  grassDark: string;
  /** Star-field style speckles instead of clouds. */
  underground: boolean;
}

export const THEMES: Record<ThemeName, Theme> = {
  day: {
    skyTop: C.skyDay,
    skyBottom: C.skyDayLow,
    soil: C.soil,
    soilDark: C.soilDark,
    soilLight: C.soilLight,
    grass: C.grass,
    grassDark: C.grassDark,
    underground: false,
  },
  dusk: {
    skyTop: C.skyDusk,
    skyBottom: C.skyDuskLow,
    soil: C.soil,
    soilDark: C.soilDark,
    soilLight: C.soilLight,
    grass: C.grass,
    grassDark: C.grassDark,
    underground: false,
  },
  cave: {
    skyTop: C.skyCave,
    skyBottom: C.skyCaveLow,
    soil: C.cavesoil,
    soilDark: C.cavesoilDark,
    soilLight: C.cavesoilLight,
    grass: C.cavegrass,
    grassDark: C.cavegrassDark,
    underground: true,
  },
};
